const initialState = {
    refreshAgentTable:'',
    searchAgentValue:'',
    updateSelectList:'',
};
export const actionTypes = {
    REFRESH_AGENT_TABLE: "REFRESH_AGENT_TABLE",
    SEARCH_AGENT_TABLE:"SEARCH_AGENT_TABLE",
    UPDATE_AGENT_SELECT:"UPDATE_AGENT_SELECT",
};

export const actions = {
    refresh_agent_table: function (data) {
        return {
            type: actionTypes.REFRESH_AGENT_TABLE,
            data
        }
    },
    search_agent_table: function (data) {
        return {
            type: actionTypes.SEARCH_AGENT_TABLE,
            data
        }
    },
    update_select_list: function (data) {
        return {
            type: actionTypes.UPDATE_AGENT_SELECT,
            data
        }
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.REFRESH_AGENT_TABLE:{
            return {...state,refreshAgentTable:action.data}
        }
        case actionTypes.SEARCH_AGENT_TABLE:{
            return {...state,searchAgentValue:action.data}
        }
        case actionTypes.UPDATE_AGENT_SELECT:{
            return {...state,updateSelectList:action.data}
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/agentReducer.js